


import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class TrackState extends Vue {

  pushState(data: any) {
    this.$store.commit("SET_HISTORY", { name: `${this.$options.name}`, data: data});
  }

  popState() {
    return this.$store.getters.history[this.$options.name];
  }
}
